//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import "@lazy-copilot/datetimepicker/dist/datetimepicker.css";
import { DateTimePicker } from "@lazy-copilot/datetimepicker";
import unity from "@/unity/unity";
import moment from "moment";

export default {
  name: "leave-request",
  components: { SuccessDialog, SuccessDialogPush, DateTimePicker },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  data(vm) {
    return {
      check_cross_per: "",
      day_select: "",
      select_leave_id: 0,
      user_approve_all: [],
      user_approve_count_status: false,
      user_approve_count_status2: false,
      date_start: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      date_end: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu_start: false,
      menu_end: false,
      leave_start_hours: "",
      leave_end_hours: "",
      leave_start_min: "",
      leave_end_min: "",
      leave_hours: [
        { text: "1 hour", value: 1 },
        { text: "2 hours", value: 2 },
        { text: "3 hours", value: 3 },
        { text: "Half day", value: 4 },
        { text: "5 hours", value: 5 },
        { text: "6 hours", value: 6 },
        { text: "7 hours", value: 7 },
        { text: "Full day", value: 8 },
      ],
      leave_min: [
        { text: "00", value: "00" },
        { text: "30", value: "30" },
      ],
      startDate: new Date(),
      endDate: new Date(),
      dialogDelete: false,
      dialogSave: false,
      dialogCancel: false,
      preview: null,
      image: null,
      preview_list: [],
      oldpreview_list: [],
      image_list: [],
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dropdownLeave: [],
      dataAll: [],
      delete_his_id: 0,
      delete_lq_id: [],
      delete_amount: 0,
      update_delete_req: {},
      headers: [
        {
          text: "Period",
          value: "period",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Leave Type",
          value: "leave_type",
          class: "bg-colorth tabletextwhite",
        },
        // {
        //   text: "Quota (Day)",
        //   value: "quota_day_show",
        //   class: "bg-colorth tabletextwhite",
        // },
        // {
        //   text: "Used",
        //   value: "user_day_show",
        //   class: "bg-colorth tabletextwhite",
        // },
        {
          text: "Quota (Day)",
          value: "balance_show",
          class: "bg-colorth tabletextwhite",
        },
      ],
      // ประกาศ key ไว้ล่วงหน้าเพื่อให้ reactive (หน้าตาใหม่ใช้ computed ที่อ่านค่าเหล่านี้)
      leave_data: {
        leaveType: null,
        leaveTypeId: 0,
        type_count: null,
        userId: null,
        departmentId: null,
        companyId: null,
        description: "",
        startDate: null,
        endDate: null,
        amount: 0,
        old_amount: null,
        old_lq_id: null,
        old_amount_list: [],
        lq_id_detail: null,
        lq_id: null,
      },
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      vacation_day: 0,
      vacation_hours: 0,
      approver_day: 0,
      approver_hours: 0,
      pending_cont: 0,
      public_cont: 0,
      textshow: "",
      delete_old_images: [],
      // ===== UI ใหม่ =====
      dragOver: false,
      holiday_dates: [],
      leaveHistoryAll: [],
    };
  },

  computed: {
    // ===== ชื่อประเภทลาที่เลือก =====
    selectedLeaveTypeName() {
      const t = this.dropdownLeave.find((x) => x.leave_type_id === this.leave_data.leaveTypeId);
      return t ? t.leave_type : "-";
    },
    // ===== ชั่วโมงที่ขอลา (คำนวณแสดงผลเท่านั้น ตอนบันทึกยังใช้ logic เดิมใน onSave) =====
    requestedHours() {
      const startH = Number(this.leave_start_hours) || 0;
      if (this.day_select === "single") return startH;
      const endH = Number(this.leave_end_hours) || 0;
      if (!this.date_start || !this.date_end || this.date_end <= this.date_start) return startH;
      const wd = this.countWeekdays(this.date_start, this.date_end);
      if (wd <= 1) return startH;
      // เหมือน onSave: วันเต็มตรงกลาง x 8 + ชั่วโมงวันแรก + ชั่วโมงวันสุดท้าย
      return (wd - 2) * 8 + startH + endH;
    },
    // ===== โควต้าคงเหลือของประเภทลาที่เลือก (ชั่วโมง) =====
    selectedBalanceHours() {
      if (!this.leave_data.leaveTypeId) return null;
      const q = this.dataAll.filter((x) => x.leave_type_id === this.leave_data.leaveTypeId);
      if (!q.length) return 0;
      return Number(q[0].balance || 0) * 8;
    },
    balanceAfterText() {
      if (this.selectedBalanceHours === null) return "-";
      const after = Math.round((this.selectedBalanceHours - this.requestedHours) * 100) / 100;
      if (after < 0) return "-" + this.formatHours(Math.abs(after));
      return this.formatHours(after, true);
    },
    // ลาเกินโควต้าคงเหลือ -> แสดงสีแดง
    isOverBalance() {
      return this.selectedBalanceHours !== null && this.requestedHours > this.selectedBalanceHours;
    },
    summaryDateText() {
      if (this.day_select === "single") return this.displayDate(this.date_start);
      return `${this.displayDate(this.date_start)} - ${this.displayDate(this.date_end)}`;
    },
    summaryDurationText() {
      const txt = (v) => {
        const o = this.leave_hours.find((x) => x.value === v);
        return o ? o.text : "-";
      };
      if (this.day_select === "single") return txt(this.leave_start_hours);
      return `${txt(this.leave_start_hours)} / ${txt(this.leave_end_hours)}`;
    },
    // ===== Upcoming: วันลาที่อนุมัติแล้ว ภายใน 90 วันข้างหน้า (เหมือนหน้า My time off) =====
    upcoming90() {
      const today = moment().startOf("day");
      const limit = moment(today).add(90, "days");
      let totalHours = 0;
      this.leaveHistoryAll.forEach((item) => {
        if (!this.isApproved(item)) return;
        const { start, end: rawEnd } = this.leaveRange(item);
        if (!start) return;
        const end = rawEnd || start;
        if (end.isBefore(today, "day") || start.isAfter(limit, "day")) return;
        const hours = Number(item.hours_amount) || 0;
        const allDays = this.countWeekdays(start, end);
        const inDays = this.countWeekdays(moment.max(start, today), moment.min(end, limit));
        totalHours += allDays > 0 ? (hours * inDays) / allDays : 0;
      });
      totalHours = Math.round(totalHours * 100) / 100;
      const days = Math.floor(totalHours / 8);
      const hours = Math.round((totalHours - days * 8) * 100) / 100;
      return { days, hours };
    },
    computedDateFromFormatted() {
      return unity.formatDate(this.date_start);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.date_end);
    },
    allowedDates() {
      return (date) => {
        date = new Date(date);
        const dayOfWeek = date.getDay();
        return dayOfWeek !== 0 && dayOfWeek !== 6; // Disable Sunday (0) and Saturday (6)
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  async mounted() {
    this.userId = localStorage.getItem(server.USER_ID);

    try {
      // 1. ตรวจสอบ approver ก่อน
      await this.loadLevelApprove(this.userId);

      // 2. โหลด history (จะได้ check_cross_per และ old quota data)
      await this.loadLeaveHistory(this.$route.params.id);

      // 3. โหลด dropdown และ quota (จะใช้ข้อมูลจาก step 2 ในการคำนวณ)
      await this.loaddataLeaveUsed(this.userId);

      // 4. โหลด quota summary
      await this.loadQuotaType();

      // 5. อัพเดทข้อความแสดง available days
      this.onLeaveTypeChange();

      this.$hideLoader();
    } catch (error) {
      console.error("❌ Error in mounted:", error);
      this.$hideLoader();
    }
  },

  methods: {
    onLeaveTypeChange() {
      // this.textshow = "test";
      if (this.dataAll && this.dataAll.length > 0) {
        const dataSet = this.dataAll.filter(
          (item) => item.leave_type_id === this.leave_data.leaveTypeId,
        );
        if (dataSet && dataSet.length == 1) {
          this.textshow = `${dataSet[0].balance_show} available this year`;
        } else if (dataSet && dataSet.length > 1) {
          this.textshow = `${dataSet[0].balance_show} available this year, ${dataSet[1].balance_show} available next year`;
        } else {
          this.textshow = `0 days available this year`;
        }
      } else {
      }
    },
    async loadQuotaType() {
      const res_leave_history = await api.getListHistoryAll(
        localStorage.getItem(server.USER_ID),
      );

      if (res_leave_history.data && res_leave_history.data.length > 0) {
        const filteredData = res_leave_history.data.filter(
          (item) => Number(item.status) === 1 || Number(item.status) === 2,
        );
        this.pending_cont = filteredData.length;
      } else {
        this.pending_cont = 0;
      }
      this.leaveHistoryAll = res_leave_history.data || [];

      // const res_quota = await api.getListByUserDashboard(localStorage.getItem(server.USER_ID))
      if (this.dataAll && this.dataAll.length > 0) {
        const filteredData = this.dataAll.filter(
          (item) => item.leave_type === "Vacation Leave",
        );
        if (filteredData.length > 0) {
          var canuse_leave = 0;
          for (const [index, item] of filteredData.entries()) {
            canuse_leave = canuse_leave + Number(item.balance);
          }

          this.vacation_day = Math.floor(canuse_leave);
          this.vacation_hours = (canuse_leave - this.vacation_day) * 8;
        } else {
          this.vacation_day = 0;
          this.vacation_hours = 0;
        }
      } else {
        this.vacation_day = 0;
        this.vacation_hours = 0;
      }

      const res_holiday = await api.getAllYear(
        Number(localStorage.getItem(server.COMPANYID)),
      );
      if (res_holiday.data && res_holiday.data.length > 0) {
        this.public_cont = res_holiday.data.length;
        this.holiday_dates = res_holiday.data.map((h) => this.holidayDateKey(h)).filter(Boolean);
      } else {
        this.public_cont = 0;
        this.holiday_dates = [];
      }

      const res_approval = await api.getAllByApproval(
        Number(localStorage.getItem(server.USER_ID)),
      );
      if (res_approval.data && res_approval.data.length > 0) {

        this.approver_day = Math.floor(
          Number(res_approval.data[0].amount) / 60 / 8,
        );
        this.approver_hours = Math.floor(
          (Number(res_approval.data[0].amount) - this.approver_day * 60 * 8) /
          60,
        );
      } else {
        this.approver_day = 0;
        this.approver_hours = 0;
      }
    },
    // ================= UI helpers (ใหม่) =================
    setDaySelect(val) {
      this.day_select = val;
      this.handleRadioDaySelect();
    },
    // 2026-09-07 -> 7 Sep 2026
    displayDate(ymd) {
      if (!ymd) return "";
      const m = moment(ymd, "YYYY-MM-DD");
      return m.isValid() ? m.format("D MMM YYYY") : ymd;
    },
    // ชั่วโมง -> "1 day" / "4 hours" / "2 days 4 hours"
    formatHours(total, showZero) {
      const t = Number(total) || 0;
      if (t <= 0) return showZero ? "0 days" : "-";
      const d = Math.floor(t / 8);
      const h = Math.round((t - d * 8) * 100) / 100;
      const parts = [];
      if (d > 0) parts.push(`${d} ${d === 1 ? "day" : "days"}`);
      if (h > 0) parts.push(`${h} ${h === 1 ? "hour" : "hours"}`);
      return parts.join(" ");
    },
    // ลากไฟล์มาวาง -> ใช้ previewMultiImage เดิม
    onDropFiles(e) {
      this.dragOver = false;
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
        this.previewMultiImage({ target: { files: e.dataTransfer.files } });
      }
    },
    // นับวันทำงาน (ไม่นับ เสาร์-อาทิตย์ และวันหยุดบริษัท)
    countWeekdays(start, end) {
      let n = 0;
      const d = moment(start).startOf("day");
      const e = moment(end).startOf("day");
      while (d.isSameOrBefore(e, "day")) {
        const isWeekend = d.day() === 0 || d.day() === 6;
        if (!isWeekend && !this.holiday_dates.includes(d.format("YYYY-MM-DD"))) n++;
        d.add(1, "day");
      }
      return n;
    },
    holidayDateKey(h) {
      const raw = h.h_date || h.holiday_date || h.hdate || h.date || h.start_date || h.h_start;
      const m = this.parseDate(raw);
      return m ? m.format("YYYY-MM-DD") : null;
    },
    parseDate(value) {
      if (!value) return null;
      const s = String(value).trim();
      if (/^\d{2}\/\d{2}\/\d{4}/.test(s)) {
        const m = moment(s.substring(0, 10), "DD/MM/YYYY");
        return m.isValid() ? m : null;
      }
      const m = moment(s);
      return m.isValid() ? m : null;
    },
    leaveRange(item) {
      let start = this.parseDate(item.str_time || item.startDate || item.start_date);
      let end = this.parseDate(item.end_time || item.endDate || item.end_date);
      if (!start && item.data_date) {
        const [a, b] = String(item.data_date).split(" - ");
        start = this.parseDate(a);
        end = this.parseDate(b);
      }
      return { start, end };
    },
    isApproved(item) {
      return Number(item.status) === 3 || String(item.status_name || "").toLowerCase().includes("approve");
    },

    async getBackList() {
      this.$router.push(`/my-time-off`);
    },
    async handleRadioDaySelect() {
      if (this.day_select == "single") {
        this.leave_end_hours == "";
      } else if (this.day_select == "multiple") {
        this.leave_end_hours == "";
      } else {
        return;
      }
    },
    async loaddataLeaveUsed(id) {
      try {
        // 1. โหลด dropdown ก่อนเสมอ
        const result_dropdown = await api.getListByUserIDV2byCompanyforEdit(
          id,
          localStorage.getItem(server.COMPANYID),
        );

        // แปลง leave_type_id เป็น Number เพื่อให้ตรงกับ v-model
        this.dropdownLeave = result_dropdown.data.map((item) => ({
          ...item,
          leave_type_id: Number(item.leave_type_id),
        }));


        // 2. โหลดข้อมูล quota
        const result = await api.getListUseByUserIDV2byCompany(
          id,
          localStorage.getItem(server.COMPANYID),
        );


        // 3. ตรวจสอบว่ามีข้อมูล quota หรือไม่
        if (result.data.length <= 0) {
          this.user_approve_count_status2 = false;
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "No Time Off",
            "You do not have any time off permitted.",
            "text-h5 red--text text-center",
          );
          return;
        } else {
          this.user_approve_count_status2 = true;
        }

        // 4. ประมวลผลข้อมูล quota ตาม check_cross_per
        let data = [];

        if (this.check_cross_per == "single_period") {
          // กรณีลาในช่วงเดียว
          result.data.forEach((item) => {
            let obj = { ...item };

            if (item.id == this.leave_data.old_lq_id) {
              // คืนโควต้าเดิมกลับไปก่อน
              const returnedAmount =
                Number(this.leave_data.old_amount) / 60 / 8;
              obj.use_leave = item.use_leave - returnedAmount;
              obj.balance = Number(item.balance) + returnedAmount;
            }

            obj.user_day_show = this.quotaListConvert(obj.use_leave);
            obj.balance_show = this.quotaListConvert(obj.balance);
            obj.quota_day_show = this.quotaListConvert(item.quota_day);

            data.push(obj);
          });
        } else if (this.check_cross_per == "cross_period") {
          // กรณีลาข้ามช่วง
          const data_cross_quota = this.leave_data.old_amount_list;

          result.data.forEach((item) => {
            let obj = { ...item };
            let quotaAdjusted = false;

            // ตรวจสอบว่า quota นี้ต้องคืนเวลาหรือไม่
            data_cross_quota.forEach((cross_item) => {
              if (item.id == cross_item.old_lq_id) {
                quotaAdjusted = true;
                const returnedAmount = Number(cross_item.old_amount) / 60 / 8;
                obj.use_leave = item.use_leave - returnedAmount;
                obj.balance = Number(item.balance) + returnedAmount;
              }
            });

            obj.user_day_show = this.quotaListConvert(obj.use_leave);
            obj.balance_show = this.quotaListConvert(obj.balance);
            obj.quota_day_show = this.quotaListConvert(item.quota_day);

            data.push(obj);
          });
        }

        this.dataAll = data;
      } catch (error) {
        console.error("❌ Error in loaddataLeaveUsed:", error);
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถโหลดข้อมูลได้",
          "text-h5 red--text text-center",
        );
      }
    },

    async loadLeaveHistory(his_id) {
      try {
        const res = await api.getLeaveHistoryByHistoryID(his_id);

        if (!res.data || res.data.length <= 0) {
          this.user_approve_count_status2 = false;
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "No Time Off",
            "You do not have any time off permitted.",
            "text-h5 red--text text-center",
          );
          return;
        }

        const historyData = res.data[0];

        if (res.data.length > 1) {
          this.check_cross_per = "cross_period";
        } else if (res.data.length == 1) {
          this.check_cross_per = "single_period";
        }

        this.leave_data.leaveType = historyData.leavetype;
        this.leave_data.leaveTypeId = Number(historyData.leavetypeid);
        this.day_select = historyData.type_count;
        this.leave_data.type_count = historyData.type_count;
        this.leave_data.userId = historyData.userid;
        this.leave_data.departmentId = historyData.departmentid;
        this.leave_data.companyId = historyData.companyid;
        this.leave_data.description = historyData.description;


        const foundInDropdown = this.dropdownLeave.find(
          (item) => item.leave_type_id === this.leave_data.leaveTypeId,
        );

        this.leave_data.startDate = historyData.startdate;
        this.leave_data.endDate = historyData.enddate;
        this.date_start = new Date(historyData.startdate)
          .toISOString()
          .substr(0, 10);
        this.date_end = new Date(historyData.enddate)
          .toISOString()
          .substr(0, 10);

        this.leave_start_hours = Number(historyData.starthour);

        if (historyData.type_count == "single") {
          this.leave_end_hours = 0;
        } else if (historyData.type_count == "multiple") {
          this.leave_end_hours = Number(historyData.endhour);
        }

        // จัดการรูปภาพ - เพิ่มเข้า preview_list ด้วย
        this.oldpreview_list = [];
        this.preview_list = []; // เคลียร์ก่อน

        if (historyData.images && historyData.images.trim() !== "") {
          const imageFiles = historyData.images.split(",");
          imageFiles.forEach((filename) => {
            const imageUrldata = `${imageUrl}/${filename.trim()}`;
            this.oldpreview_list.push(imageUrldata);
            this.preview_list.push(imageUrldata); // เพิ่มเข้า preview_list ด้วย
          });
        }


        if (this.check_cross_per == "single_period") {
          this.leave_data.old_amount = historyData.amount_detail;
          this.leave_data.old_lq_id = historyData.lq_id_detail;
          this.delete_lq_id = [{ old_lq_id: historyData.lq_id_detail }];


        } else if (this.check_cross_per == "cross_period") {
          const data_cross_per = res.data.map((item) => ({
            old_amount: item.amount_detail,
            old_lq_id: item.lq_id_detail,
          }));

          this.leave_data.old_amount_list = data_cross_per;
          this.delete_lq_id = data_cross_per;

        }

      } catch (error) {
        console.error("❌ Error in loadLeaveHistory:", error);
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถโหลดประวัติการลาได้",
          "text-h5 red--text text-center",
        );
      }
    },

    async checkHoliday(date, mode) {
      // alert(date)
      const res_date = await api.getLeaveHolidayByDate(
        date,
        Number(localStorage.getItem(server.COMPANYID)),
      );

      if (res_date.data.length > 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          `ไม่สามารถเลือกได้เนื่องจาก ${unity.formatDate(date)} เป็นวันหยุด ${res_date.data[0].h_name
          }`,
          "text-h5 red--text text-center",
        );
        return;
      }
    },
    async loadLevelApprove(userId) {
      const res_acc = await api.getAccountid(userId);
      // console.log("res_acc", JSON.stringify(res_acc.data));

      if (
        res_acc.data[0].approver_level1 !== null ||
        res_acc.data[0].approver_level1 !== ""
      ) {
        this.user_approve_count_status = true;
        this.user_approve_all.push(res_acc.data[0].approver_level1);
      } else {
        this.user_approve_count_status = false;

        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "ไม่มีผู้อนุมัติ",
          "คุณไม่มีผู้อนุมัติ กรุณาเพิ่มผู้อนุมัติด้วย",
          "text-h5 red--text text-center",
        );
        return;
      }

      if (
        res_acc.data[0].approver_level2 !== null ||
        res_acc.data[0].approver_level2 !== ""
      ) {
        this.user_approve_count_status = true;
        this.user_approve_all.push(res_acc.data[0].approver_level2);
      }

      if (
        res_acc.data[0].approver_level3 !== null ||
        res_acc.data[0].approver_level3 !== ""
      ) {
        this.user_approve_count_status = true;
        this.user_approve_all.push(res_acc.data[0].approver_level3);
      }
    },

    checkDateFormat(str_date) {
      var r_date = "";

      if (str_date.length == 1) {
        r_date = `0${str_date}`;
      } else {
        r_date = str_date;
      }
      return r_date;
    },

    async onSave() {
      this.dialogSave = false;

      //validate ข้อมูล
      if (this.leave_data.leaveTypeId == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณาเลือกประเภทการลา",
          "text-h5 red--text text-center",
        );
        return;
      }
      if (
        this.leave_start_hours === null ||
        this.leave_start_hours === "" ||
        this.leave_start_hours === 0
      ) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "Please select a time period ",
          "text-h5 red--text text-center",
        );
        return;
      }

      const res_date_start = await api.getLeaveHolidayByDate(
        this.date_start,
        Number(localStorage.getItem(server.COMPANYID)),
      );
      if (res_date_start.data.length > 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          `ไม่สามารถเลือกได้เนื่องจาก ${unity.formatDate(
            this.date_start,
          )} เป็นวันหยุด ${res_date_start.data[0].h_name}`,
          "text-h5 red--text text-center",
        );
        return;
      }

      if (this.day_select == "multiple") {
        if (this.date_start >= this.date_end) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            "คุณเลือกช่วงเวลาไม่ถูกต้อง",
            "text-h5 red--text text-center",
          );
          return;
        }

        const res_date_end = await api.getLeaveHolidayByDate(
          this.date_end,
          Number(localStorage.getItem(server.COMPANYID)),
        );
        if (res_date_end.data.length > 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            `ไม่สามารถเลือกได้เนื่องจาก ${unity.formatDate(
              this.date_end,
            )} เป็นวันหยุด ${res_date_end.data[0].h_name}`,
            "text-h5 red--text text-center",
          );
          return;
        }

        if (
          this.leave_end_hours === null ||
          this.leave_end_hours === "" ||
          this.leave_end_hours === 0
        ) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            "Please select a time period ",
            "text-h5 red--text text-center",
          );
          return;
        }
      }

      //รวมเวลา start end
      if (this.day_select == "single") {
        this.leave_data.startDate = this.date_start + " 08:30";
        this.leave_data.endDate = this.date_start + " 17:30";
      } else if (this.day_select == "multiple") {
        this.leave_data.startDate = this.date_start + " 08:30";
        this.leave_data.endDate = this.date_end + " 17:30";
      } else {
        return;
      }
      //end validate ข้อมูล

      //เช็ค เวลาตรงกับช่วงเวลาที่มีหรือไหม
      let res_chk_period = [];
      if (this.day_select == "single") {
        res_chk_period = await api.getAllCheckPeriodByLeaveType(
          localStorage.getItem(server.USER_ID),
          this.date_start,
          this.date_start,
          this.leave_data.leaveTypeId,
        );
      } else if (this.day_select == "multiple") {
        res_chk_period = await api.getAllCheckPeriodByLeaveType(
          localStorage.getItem(server.USER_ID),
          this.date_start,
          this.date_end,
          this.leave_data.leaveTypeId,
        );
      } else {
        return;
      }


      if (res_chk_period.data.length == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "วันลา ไม่อยู่ในช่วงที่กำหนด",
          "text-h5 red--text text-center",
        );
        return;
      }
      //end การเช็คช่วงเวลา

      let period_data = [];
      period_data = res_chk_period.data;

      const millisecondsInOneDay = 24 * 60 * 60 * 1000;

      // let startDate = new Date(this.date_start);
      // let endDate = new Date(this.date_end);


      let sum_avg_minutes = 0;
      let avg_minutes_list = [];
      let leave_quota_list = "";

      if (this.day_select == "single") {
        //start คำนวณวันลา
        let avg_minutes = 0; //เวลาที่ลา เป็นนาที
        avg_minutes = Number(this.leave_start_hours) * 60;
        //end คำนวณวันลา

        // //start เช็คโคต้าวันลา
        var quota_amt = 0; //โควต้าวันลาเป็นนาที

        this.dataAll.forEach((item) => {
          if (item.id == period_data[0].leave_quota_id) {
            this.leave_data.lq_id_detail = period_data[0].leave_quota_id;
            quota_amt = item.balance * 480;
          }
        });

        if (avg_minutes > quota_amt) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ลาเกิน",
            "คุณลาเกินวันลาที่มี",
            "text-h5 red--text text-center",
          );
          return;
        }
        //end เช็คโคต้าวันลา

        //start เพิ่มข้อมูลลาไม่เกิน1วัน
        this.leave_data.amount = avg_minutes;
        this.leave_data.userId = localStorage.getItem(server.USER_ID);
        this.leave_data.departmentId = localStorage.getItem(
          server.DEPARTMENT_ID,
        );
        this.leave_data.companyId = localStorage.getItem(server.COMPANYID);

        this.$showLoader();

        let formData = new FormData();

        this.image_list.forEach((x, index) => {
          formData.append(`image`, x);
        });

        const keptOldImages = this.oldpreview_list
          .filter((url) => this.preview_list.includes(url)) // เก็บเฉพาะรูปเก่าที่ยังไม่ถูกลบ
          .map((url) => url.split("/").pop())               // ดึงชื่อไฟล์จาก URL
          .join(",");


        formData.append("images", keptOldImages.toString());
        formData.append("leaveType", this.leave_data.leaveTypeId.toString());
        formData.append("leaveTypeId", this.leave_data.leaveTypeId.toString());
        formData.append("approve_id_now", this.user_approve_all[0]);
        formData.append(
          "startDate",
          this.leave_data.startDate.replace("+07:00", ""),
        );
        formData.append("startHour", this.leave_start_hours);
        formData.append(
          "endDate",
          this.leave_data.endDate.replace("+07:00", ""),
        );
        formData.append("endHour", 0);
        formData.append("type_count", this.day_select);
        formData.append("description", this.leave_data.description);
        formData.append("userId", this.leave_data.userId);
        formData.append("departmentId", this.leave_data.departmentId);
        formData.append("companyId", this.leave_data.companyId);
        formData.append("amount", this.leave_data.amount);
        formData.append("lq_id_detail", this.leave_data.lq_id_detail);

        const res_h = await api.updateLeaveHistory(
          this.$route.params.id,
          formData,
        );
        if (res_h.status == 200 || res_h.status == 201) {
          // console.log("res_h:", JSON.stringify(res_h.data));
          // this.user_approve_all.forEach((item) => {
          //   var data = {
          //     leave_his_id: res_h.data.module_id,
          //     approve_id: item,
          //   };
          //   api.addLeaveApproveDetail(data);
          // });

          // ✅ เพิ่ม: ลบไฟล์รูปเก่าที่ถูกลบออกจากฟอร์ม (เฉพาะตอน submit สำเร็จ)
          if (this.delete_old_images.length > 0) {
            try {
              for (const filename of this.delete_old_images) {
                const datadel = {
                  modulename: "Pro_file",
                  filetype: "image",
                  refid: "",
                  filename: filename,
                };

                await api.deleteFileStore({
                  params: datadel,
                });
              }

              this.delete_old_images = [];
            } catch (error) {
              console.error("❌ Error deleting old images:", error);
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Error",
                "ไม่สามารถลบรูปภาพเก่าได้",
                "text-h5 red--text text-center",
              );
              this.$hideLoader();
              return;
            }
          }

          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Request Submitted",
            "You have submitted this request.",
            "text-h5 green--text text-center",
            "/my-time-off",
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "บันทึกข้อมูลไม่สำเร็จ",
            "text-h5 red--text text-center",
          );
        }
        this.$hideLoader();
      } else if (this.day_select == "multiple") {
        let quota_check = 0;
        for (const [index, item] of period_data.entries()) {
          let avg_minutes = 0;

          let startDateMany = new Date(item.leave_date_start);
          let endDateMany = new Date(item.leave_date_end);

          while (startDateMany <= endDateMany) {
            const dayOfWeekMany = startDateMany.getDay();

            // Check if the day is not Saturday (6) or Sunday (0)
            if (dayOfWeekMany !== 6 && dayOfWeekMany !== 0) {
              var data_check = startDateMany.toISOString().substr(0, 10);
              var res_date_check = await api.getLeaveHolidayByDate(
                data_check,
                Number(localStorage.getItem(server.COMPANYID)),
              );
              if (res_date_check.data.length == 0) {
                avg_minutes += 8 * 60;
              }
            }

            startDateMany.setTime(
              startDateMany.getTime() + millisecondsInOneDay,
            );
          }

          //start บวกขอบ ของวัน
          if (period_data.length == 1) {
            avg_minutes =
              avg_minutes -
              2 * 8 * 60 +
              Number(this.leave_start_hours) * 60 +
              Number(this.leave_end_hours) * 60;
          } else if (period_data.length > 1) {
            if (index == 0) {
              avg_minutes =
                avg_minutes - 1 * 8 * 60 + Number(this.leave_start_hours) * 60;
            }
            if (index == period_data.length - 1) {
              avg_minutes =
                avg_minutes - 1 * 8 * 60 + Number(this.leave_end_hours) * 60;
            }
          } else {
            return;
          }

          //end บวกขอบ ของวัน
          //start เช็คโคต้าวันลา
          var quota_amt = 0; //โควต้าวันลาเป็นนาที

          this.dataAll.forEach((item) => {
            if (Number(item.id) == Number(period_data[index].leave_quota_id)) {
              this.leave_data.lq_id = period_data[index].leave_quota_id;
              quota_amt = Number(item.balance) * 480;
            }
          });



          if (avg_minutes > quota_amt) {
            quota_check = 1;
          }
          //end เช็คโคต้าวันลา

          // console.log("avg_minutes: " + avg_minutes)
          sum_avg_minutes += avg_minutes;
          if (index > 0) {
            leave_quota_list += `,${item.leave_quota_id}`;
          } else {
            leave_quota_list += `${item.leave_quota_id}`;
          }

          avg_minutes_list.push({
            leave_quota_id: item.leave_quota_id,
            avg_minutes: avg_minutes,
          });
        }

        // alert(quota_check)
        if (quota_check == 1) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "ลาเกิน",
            "คุณลาเกินวันลาที่มี",
            "text-h5 red--text text-center",
          );
          return;
        }

        //start เพิ่มข้อมูลลาเกิน1วัน
        this.leave_data.amount = sum_avg_minutes;
        this.leave_data.userId = localStorage.getItem(server.USER_ID);
        this.leave_data.departmentId = localStorage.getItem(
          server.DEPARTMENT_ID,
        );
        this.leave_data.companyId = localStorage.getItem(server.COMPANYID);

        this.$showLoader();

        // console.log("leave_data:", JSON.stringify(this.leave_data));

        let formData = new FormData();

        this.image_list.forEach((x, index) => {
          formData.append(`image`, x);
        });

        const keptOldImages = this.oldpreview_list
          .filter((url) => this.preview_list.includes(url)) // เก็บเฉพาะรูปเก่าที่ยังไม่ถูกลบ
          .map((url) => url.split("/").pop())               // ดึงชื่อไฟล์จาก URL
          .join(",");


        formData.append("images", keptOldImages.toString());
        formData.append("leaveType", this.leave_data.leaveTypeId.toString());
        formData.append("leaveTypeId", this.leave_data.leaveTypeId.toString());
        formData.append("approve_id_now", this.user_approve_all[0]);
        formData.append(
          "startDate",
          this.leave_data.startDate.replace("+07:00", ""),
        );
        formData.append("startHour", this.leave_start_hours);
        formData.append(
          "endDate",
          this.leave_data.endDate.replace("+07:00", ""),
        );
        formData.append("endHour", this.leave_end_hours);
        formData.append("type_count", this.day_select);
        formData.append("description", this.leave_data.description);
        formData.append("userId", this.leave_data.userId);
        formData.append("departmentId", this.leave_data.departmentId);
        formData.append("companyId", this.leave_data.companyId);
        formData.append("amount", this.leave_data.amount);
        formData.append("lq_id_detail", leave_quota_list);

        let lq_id_v = "";
        avg_minutes_list.forEach((item, index) => {
          if (index == 0) {
            lq_id_v += `{ "lq_id_v": ${item.leave_quota_id}, "avg_minutes": ${item.avg_minutes}}`;
          } else {
            lq_id_v += `|{ "lq_id_v": ${item.leave_quota_id}, "avg_minutes": ${item.avg_minutes}}`;
          }
        });

        formData.append("lq_id_v", lq_id_v);

        const res_h = await api.updateLeaveHistory(
          this.$route.params.id,
          formData,
        );
        if (res_h.status == 200 || res_h.status == 201) {
          if (this.delete_old_images.length > 0) {
            try {
              for (const filename of this.delete_old_images) {
                const datadel = {
                  modulename: "Pro_file",
                  filetype: "image",
                  refid: "",
                  filename: filename,
                };

                await api.deleteFileStore({
                  params: datadel,
                });
              }

              this.delete_old_images = [];
            } catch (error) {
              console.error("❌ Error deleting old images:", error);
              this.$store.state.global_dialog = true;
              this.setupAlertDialog(
                true,
                "Error",
                "ไม่สามารถลบรูปภาพเก่าได้",
                "text-h5 red--text text-center",
              );
              this.$hideLoader();
              return;
            }
          }

          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Request Submitted",
            "You have submitted this request.",
            "text-h5 green--text text-center",
            "/my-time-off",
          );
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "บันทึกข้อมูลไม่สำเร็จ",
            "text-h5 red--text text-center",
          );
        }
        this.$hideLoader();
      } else {
        return;
      }
    },

    async onCancelSave() {
      this.dialogCancel = false;
      this.$showLoader();

      const fail = () => {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(true, "Information Saved", "บันทึกข้อมูลไม่สำเร็จ", "text-h5 red--text text-center");
      };

      try {
        if (!this.delete_lq_id || this.delete_lq_id.length === 0) return fail();

        // ลบ leave history
        const res_dlq = await api.delete_leaveH(this.$route.params.id);
        if (!res_dlq.data || !res_dlq.data.id) return fail();

        await api.delete_leaveQHD(this.$route.params.id);
        await api.delete_leaveAD(this.$route.params.id);

        // คืนโควต้าทีละ quota (รอให้เสร็จทีละตัว + ใช้ object ใหม่ทุกครั้ง)
        for (const item of this.delete_lq_id) {
          const quota = this.dataAll.find((q) => q.id == item.old_lq_id);
          const body = { use_leave: quota ? quota.use_leave : 0 };

          const res_ulq = await api.updateQuota(item.old_lq_id, body);
          if (!(res_ulq.status == 200 || res_ulq.status == 201)) return fail();
        }

        this.$hideLoader();
        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(true, "Request Canceled", "You have canceled this request.",
          "text-h5 green--text text-center", "/my-time-off");
      } catch (error) {
        console.error("❌ Error in onCancelSave:", error);
        fail();
      }
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    saveItemConfirm() {
      this.dialogSave = true;
    },
    cancelReauest() {
      this.dialogCancel = true;
    },
    closeSave() {
      this.dialogSave = false;
    },
    closeCancel() {
      this.dialogCancel = false;
    },
    deleteItemConfirm(index) {
      this.indeximage = index;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.indeximage = null;
      this.dialogDelete = false;
    },
    async removeimage() {
      const removedUrl = this.preview_list[this.indeximage];

      // เช็คว่าเป็นรูปเก่า (มีอยู่จริงบน server) หรือรูปใหม่ (ยัง local)
      const oldIndex = this.oldpreview_list.indexOf(removedUrl);

      if (oldIndex !== -1) {
        // เป็นรูปเก่า -> เก็บชื่อไฟล์ไว้ก่อน รอลบจริงตอน submit
        const filename = removedUrl.split("/").pop();
        this.delete_old_images.push(filename);
        this.oldpreview_list.splice(oldIndex, 1);
      } else {
        // เป็นรูปใหม่ที่ยังไม่ upload -> ลบออกจาก image_list ตรงตัว
        const newImageIndex = this.indeximage - this.oldpreview_list.length;
        if (newImageIndex >= 0 && newImageIndex < this.image_list.length) {
          this.image_list.splice(newImageIndex, 1);
        }
      }

      this.preview_list.splice(this.indeximage, 1);
      this.dialogDelete = false;
    },
    quotaListConvert: function (H) {
      var d = 0;
      var h = 0;
      var m = 0;
      var tmp1 = parseFloat(H * 480);
      var tmp_final;

      var tmp_d = tmp1 / 480;

      d = Math.floor(tmp_d);
      h = Math.floor((tmp_d - d) * 8);
      m = Math.floor(((tmp_d - d) * 8 - h) * 60);

      tmp_final = `${d} days ${h} hour`;

      return tmp_final;
    },

    previewMultiImage: function (event) {
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_list.push(e.target.result);
          };
          if (input.files[index].type.split("/")[0] === "image") {
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      console.log(this.image_list);
    },
  },
};
